import { UPDATE_USER } from "../actions/updateUserName";

export const updateUserDetails = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        action
      };
    default:
      return state;
  }
};